import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Navbar from "./Navbar";
import { PROGRAM_TYPES } from "./constants/programTypes";
import EnrollmentCenterInfoPage from "./EnrollmentCenterInfoPage";
import WaitTimes from "./WaitTimes";
import WaitTimesProgramPicker from "./WaitTimesProgramPicker";
import { Box, Flex, List, ListItem, Link } from "@chakra-ui/react";

export default function App() {
  return (
    <Box
      as="footer"
      // mt="100px"
      color="gray.400"
      pb="20px"
      bg="#202B4A"
      zIndex={1000}
      pos="relative"
    >
      <Box textAlign="center">
        <Flex direction="column" justifyContent="center" alignItems="center">
          <Link href="index.html" m="20px">
            <img
              src="/locations/logo-on-dark.svg"
              alt="Appointment Scanner Logo"
              width="300px"
            />
          </Link>
          <Box mb="20px">Appointment Scanner by WarpSpeed Ventures LLC</Box>
          <Box mb="20px">
            &copy; {new Date().getFullYear()} Appointment Scanner, all rights
            reserved
          </Box>
          <Flex as="nav" direction="column">
            <List display="inline">
              <ListItem>
                <Link href="/terms.html">Terms of Use</Link>
              </ListItem>
              <ListItem>
                <Link href="/privacy.html">Privacy Policy</Link>
              </ListItem>
              <ListItem>
                <Link href="/refunds.html">Refund Policy</Link>
              </ListItem>
              <ListItem>
                <Link href="mailto:support@appointmentscanner.com">
                  Contact
                </Link>
              </ListItem>
              <ListItem>
                <Link href="https://forms.gle/HPZqvDvTtfM2gJvQA">
                  Give feedback
                </Link>
              </ListItem>
            </List>
          </Flex>
        </Flex>

        <Box mt="10px">
          Appointment Scanner is not affiliated with or endorsed by any
          government agencies or programs. It is a privately-owned information
          service that helps users find interview appointments.
          <a href="/intellectual-property.html">More info</a>
        </Box>
      </Box>
    </Box>
  );
}
